import { Button } from "@mui/material";
import { apiSetAlert } from "api/appApi";
import { apiGetProperty } from "api/property";
import BasicSelect from "components/BasicInputs/BasicSelect";
import { SelectBox } from "components/Input";
import { setSelectItemLabels } from "helpers";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { selectTableItems } from "store/actions";
import { updateForm } from "store/actions/formAction";
import { useAppSelector } from "store/store";

const ProductPropertyTab = (props: any) => {
    const [data, setData] = useState([])
    const { id } = useParams();

    const [property, setProperty] = useState<{ [key: string]: { id: number | string, title: string } }>({})
    const [arrProductName, setArrProductName] = useState<{ id: Array<string | number>, value: string }[]>([])
    //@ts-ignore
    const editItem = useAppSelector((state) => state.formReducer?.editItem)
    const EditProductProperty = id ? editItem?.productProperties?.map((item: any) => { return { id: item.Product_Property.id, value: item.id } }) : []

    const dispatch = useDispatch()
    const getFullData = () => {
        //@ts-ignore
        dispatch(apiGetProperty({
            cb: (res: any) => {
                setData(res.data)
            }
        }))
    }
    useEffect(() => {
        getFullData()

        return () => {

        }
    }, [])
    useEffect(() => {
        dispatch(updateForm("productProperty", arrProductName, true, false));



    }, [arrProductName])
    const getDefaultValue = (id: any) => {
        const val = EditProductProperty.find((item: any) => item.id === id)
        if (val) {
            return val.value
        }
        return null
    }
    function removeItem(item: any) {
        console.log(arrProductName, 'arrProductName')
        const newItems = arrProductName.filter((i: any) => i.value !== item.value);
        setArrProductName(newItems);
    }
    return <>

        {
            data.length > 0 ?
                <div className="row">
                    {data.map((item: any) => {
                        return (
                            <div key={item.id} className="col-lg-6 col-md-6 col-sm-6 col-xs-6 style-padding-inputs">
                                <BasicSelect
                                    defaultValue={getDefaultValue(item.id)}
                                    withClear
                                    onClear={() => {
                                        setProperty(state => {
                                            delete state[item.id]
                                            return {}
                                        })
                                    }}
                                    label={item.fa_title}
                                    onChange={(val, option) => {
                                        setProperty(state => { return { ...state, [item.id]: { id: val, title: option.fa_title } } })
                                    }}
                                    options={setSelectItemLabels(item.Product_Property_Items, "id", 'fa_title')}
                                />
                            </div>
                        )
                    })
                    }
                    <div className="col-lg-12 col-md-12 col-sm-12 style-class-box-inputs place-content-center flex flex-col gap-5 mt-5">
                        <span>محصولات با ویژگی</span>
                        <div className="border-slate-300 border p-3 rounded-md  flex flex-col h-44 gap-2 overflow-y-auto max-h-44 ">
                            {
                                arrProductName.map((item, ix) => {

                                    return (<div key={ix} className="hover:bg-blue-5 p-2 flex justify-between rounded-md">
                                        <span>{item.value}</span>
                                        <span onClick={() => { removeItem(item) }} className="text-red-800 cursor-pointer">X</span>
                                    </div>)
                                })
                            }




                        </div>
                        <Button onClick={() => {
                            setArrProductName(state => {
                                if (Object.keys(property).length > 0) {
                                    const items = [...state]
                                    let value: { id: Array<string | number>, value: string } = { id: [], value: "" }
                                    Object.values(property).map((item) => {
                                        console.log(item, 'item')
                                        value.id.push(item.id)
                                        value.value += item.title + " "
                                    })
                                    const valueCaption = value.value.trim()
                                    if (items.findIndex(x => x.value.trim().toLowerCase() === valueCaption) === -1) {
                                        items.push({ id: value.id, value: value.value })
                                        // setProperty({})
                                        return items
                                    } else {
                                        // @ts-ignore
                                        dispatch(apiSetAlert("آیتم مورد نظر تکراری می باشد", "warning"));
                                        return state
                                        // }

                                    }
                                } else {
                                    // @ts-ignore
                                    dispatch(apiSetAlert("انتخاب حداقل یک فیلد اجباری می باشد", "warning"));
                                    return state
                                }

                            })
                        }} variant="contained">اضافه کردن آیتم</Button>

                    </div>
                </div>
                : 'ویژگی ای برای سیستم ثبت نشده است'
        }
    </>
}

export default ProductPropertyTab;